import React from 'react';
import { motion } from 'framer-motion';
import { Fingerprint } from './Fingerprint';
export function Logo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-3 ${className}`} data-id="element-257" data-mp="8uwep8vroj2j">
      <motion.div whileHover={{
      rotate: 5,
      scale: 1.05
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 20
    }} data-id="element-258" data-mp="3qaw38u3122bd">
        <Fingerprint className="w-9 h-9 text-brand-primary" data-id="element-259" data-mp="mtdxcs6tf5dl" />
      </motion.div>
      <span className="text-[clamp(1.3rem,2.5vw,1.6rem)] font-black tracking-[-0.02em]" data-id="element-260" data-mp="rqw6aiku1kll">
        <span className="text-white" data-id="element-261" data-mp="dsxzby8ucqg4">Core</span>
        <span className="text-brand-primary" data-id="element-262" data-mp="du933y2ady78">Print</span>
      </span>
    </div>;
}